// src/ProductDeepLinks/ProductDeepLinks.tsx
import ButtonDropdown from "@cloudscape-design/components/button-dropdown";
import { useAppTranslation } from "@amzn/awsmp-max-translations";
import { jsx } from "react/jsx-runtime";
var ProductDeepLinks = ({
  pdpUrl,
  procurementUrl,
  requestADemoUrl,
  requestPrivateOfferUrl,
  procureFreeTrialUrl,
  onCreateProposal,
  fullWidth = false,
  disabled = false,
  logger
}) => {
  const { t } = useAppTranslation();
  const allItems = [];
  allItems.push({
    id: "view-details",
    text: t("viewProductDetails"),
    href: pdpUrl,
    external: true,
    externalIconAriaLabel: t("opensInNewTab")
  });
  if (procurementUrl) {
    allItems.push({
      id: "view-purchase-options",
      text: t("viewPurchaseOptions"),
      href: procurementUrl,
      external: true,
      externalIconAriaLabel: t("opensInNewTab")
    });
  }
  if (procureFreeTrialUrl) {
    allItems.push({
      id: "try-for-free",
      text: t("tryForFree"),
      href: procureFreeTrialUrl,
      external: true,
      externalIconAriaLabel: t("opensInNewTab")
    });
  }
  if (requestADemoUrl) {
    allItems.push({
      id: "request-demo",
      text: t("requestDemo"),
      href: requestADemoUrl,
      external: true,
      externalIconAriaLabel: t("opensInNewTab")
    });
  }
  if (requestPrivateOfferUrl) {
    allItems.push({
      id: "request-private-offer",
      text: t("requestPrivateOffer"),
      href: requestPrivateOfferUrl,
      external: true,
      externalIconAriaLabel: t("opensInNewTab")
    });
  }
  if (onCreateProposal) {
    allItems.push({
      id: "create-proposal",
      text: t("createProposal"),
      iconName: "gen-ai"
    });
  }
  const items = [
    {
      items: allItems
    }
  ];
  const handleItemClick = (event) => {
    if (event.detail.id === "create-proposal" && onCreateProposal) {
      logger?.biMetric({
        metricName: "Click",
        value: 1,
        unit: "Count",
        dimensions: {
          ClickSelect: "create-proposal-button"
        }
      });
      onCreateProposal();
    }
    if (event.detail.id === "view-details") {
      logger?.biMetric({
        metricName: "Click",
        value: 1,
        unit: "Count",
        dimensions: {
          ClickSelect: "view-details-button"
        }
      });
    }
    if (event.detail.id === "view-purchase-options") {
      logger?.biMetric({
        metricName: "Click",
        value: 1,
        unit: "Count",
        dimensions: {
          ClickSelect: "view-purchase-options-button"
        }
      });
    }
    if (event.detail.id === "try-for-free") {
      logger?.biMetric({
        metricName: "Click",
        value: 1,
        unit: "Count",
        dimensions: {
          ClickSelect: "try-for-free-button"
        }
      });
    }
    if (event.detail.id === "request-demo") {
      logger?.biMetric({
        metricName: "Click",
        value: 1,
        unit: "Count",
        dimensions: {
          ClickSelect: "request-demo-button"
        }
      });
    }
    if (event.detail.id === "request-private-offer") {
      logger?.biMetric({
        metricName: "Click",
        value: 1,
        unit: "Count",
        dimensions: {
          ClickSelect: "request-private-offer-button"
        }
      });
    }
  };
  return /* @__PURE__ */ jsx(ButtonDropdown, { items, variant: "normal", fullWidth, onItemClick: handleItemClick, disabled, children: t("getStarted") });
};
export {
  ProductDeepLinks
};
//# sourceMappingURL=index.js.map
